/* eslint-disable prettier/prettier */
; (() => {
  const MAX_WINDOW_WIDTH = 842;
  // if (window.innerWidth < MAX_WINDOW_WIDTH) return;

  const carousel = document.getElementById('homeHeroSlider');
  if (!carousel) return;

  const slides = carousel.querySelectorAll('.carousel-item');
  if (!slides) return;

  slides.forEach(slide => {
    if (slide.querySelector('.carousel-caption')) {
      if (!slide.classList.contains('has-content-media')) {
        slide.classList.add('has-content-media');
      }
    } else {
      if (!slide.classList.contains('has-media')) {
        slide.classList.add('has-media');
      }
    }
  });

  let MAX_HEIGHT = 350; // init max height

  const handleResize = () => {
    const slideHeights = [];
    const contentSlides = carousel.querySelectorAll('.carousel-item.has-content-media');
    const mediaSlides = carousel.querySelectorAll('.carousel-item-content');
    const contentImages = carousel.querySelectorAll('.carousel-item img');

    if (!contentSlides || !contentImages) return;

    // resets min-height and max height of elements
    slides.forEach(slide => {
      slide.style.minHeight = `unset`;
    });
    mediaSlides.forEach(slide => {
      slide.style.minHeight = `unset`;
    });
    contentImages.forEach(image => {
      image.style.maxHeight = `unset`;
    });

    // if (window.innerWidth < MAX_WINDOW_WIDTH) return;

    contentSlides.forEach(item => {
      let isActive = item.classList.contains('active');
      if (!isActive) item.classList.add('active');
      slideHeights.push(item.offsetHeight);
      if (!isActive) item.classList.remove('active');
    });

    const maxHeightValue = Math.max.apply(null, slideHeights);

    if (maxHeightValue > 0) {
      MAX_HEIGHT = maxHeightValue;
    }
    slides.forEach(slide => {
      slide.style.minHeight = `${MAX_HEIGHT}px`;
    });
    mediaSlides.forEach(slide => {
      slide.style.minHeight = `${MAX_HEIGHT}px`;
    });
    contentImages.forEach(image => {
      image.style.maxHeight = `${MAX_HEIGHT}px`;
    });
  };
  handleResize();

  let handleResizeTimeout = null;
  const resizeListener = () => {
    clearTimeout(handleResizeTimeout);
    handleResizeTimeout = setTimeout(handleResize, 200);
  }
  window.addEventListener('resize', resizeListener);
})();


// instant transition handler
(() => {
  const buttons = document.querySelectorAll('#homeHeroSlider .carousel-indicators button');
  if (!buttons) return;
  const slides = document.querySelectorAll('#homeHeroSlider .carousel-inner .carousel-item');
  if (!slides) return;

  const addInstantTransitionClass = () => {
    const slide = document.querySelector('#homeHeroSlider .carousel-item.active');
    slide.classList.add('click-transition');
  };

  const removeInstantTransitionClass = () => {
    slides.forEach(slide => {
      slide.classList.remove('click-transition');
    });
  };

  let timeout = null;

  const handleClick = () => {
    if (timeout) {
      clearTimeout(timeout);
    }
    addInstantTransitionClass();

    timeout = setTimeout(removeInstantTransitionClass, 450);
  }
  buttons.forEach(button => button.addEventListener('click', handleClick));
})();